routing.$inject = ['$stateProvider'];

export default function routing($stateProvider) {
    $stateProvider
        .state('subscriberForm', {
            url: '/subscriber/subscriber-form',
            abstract: true,
            ncyBreadcrumb: {
                label: 'BREADCRUMBS:SUBSCRIBER:IMPORT_SUBSCRIBER_FORM'
            }
        })

        .state('subscriberForm.index', {
            url: '',
            controller: 'SubscriberFormCtrl',
            controllerAs: 'index',
            template: require('../../../views/subscriber/subscriberForm/index.html'),
            ncyBreadcrumb: {
                label: 'BREADCRUMBS:SUBSCRIBER:IMPORT_SUBSCRIBER_FORM',
                parent: 'subscriberForm'
            }
        })

        .state('subscriberForm.builder', {
            url: '/builder',
            controller: 'SubscriberFormBuilderCtrl',
            controllerAs: 'builder',
            template: require('../../../views/subscriber/subscriberForm/editSubscriberForm.html'),
            ncyBreadcrumb: {
                label: 'BREADCRUMBS:CREATE',
                parent: 'subscriberForm.index'
            }
        })

        .state('subscriberForm.edit', {
            url: '/{id}/builder',
            controller: 'SubscriberFormBuilderCtrl',
            controllerAs: 'builder',
            template: require('../../../views/subscriber/subscriberForm/editSubscriberForm.html'),
            ncyBreadcrumb: {
                label: 'BREADCRUMBS:EDIT',
                parent: 'subscriberForm.index'
            }
        })

        .state('subscriberForm.email', {
            url: '/{id}/email',
            controller: 'SubscriberFormEmailCtrl',
            controllerAs: 'subscriberFormEditor',
            template: require('../../../views/subscriber/subscriberForm/email.html'),
            ncyBreadcrumb: {
                label: 'BREADCRUMBS:SUBSCRIBER_FORM:EMAIL'
            }
        })

        .state('subscriberForm.email.edit', {
            url: '/{emailId}',
            controller: 'SubscriberFormEmailCtrl',
            controllerAs: 'subscriberFormEditor',
            template: require('../../../views/subscriber/subscriberForm/email.html'),
            ncyBreadcrumb: {
                label: 'BREADCRUMBS:AUTOMATION:EDIT'
            }
        })

        .state('subscriberForm.settings', {
            url: '/{id}/settings',
            controller: 'SubscriberFormSettingsCtrl',
            controllerAs: 'settings',
            template: require('../../../views/subscriber/subscriberForm/subscriberFormSettings.html'),
            ncyBreadcrumb: {
                label: 'BREADCRUMBS:SUBSCRIBER:SETTING'
            }
        })

        .state('subscriberForm.summary', {
            url: '/{id}/summary',
            controller: 'SubscriberFormSummaryCtrl',
            controllerAs: 'summary',
            template: require('../../../views/subscriber/subscriberForm/summary.html'),
            ncyBreadcrumb: {
                label: 'BREADCRUMBS:SUBSCRIBER_FORM:SUMMARY'
            }
        })
}